import React, { useState } from "react";
import DataTable from 'src/components/data-table';
import { useSelector } from 'react-redux';
import API_ROUTES from 'src/config/api';
import { Check, XIcon, Loader2 } from 'lucide-react';
import { Auth } from "aws-amplify";
import axios from "axios";
import ReactCountryFlag from "react-country-flag";

const RowFormatter = ({ item, organisation }) => {
  const [binState, setBinState] = useState(item.blocked);
  const [updating, setUpdating] = useState(false);

  const updateBinState = async () => {
    setUpdating(true);
    const user = await Auth.currentAuthenticatedUser();

    await axios(
      API_ROUTES.user['organisation:bin-rule:set'](organisation.organisation),
      {
        method: 'post',
        data: {
          bin: item.id,
          blocked: !binState,
        },
        headers: { Authorization: `Bearer ${user.signInUserSession.idToken.jwtToken}` },
      }
    );

    setBinState(!binState);
    setUpdating(false);
  }

  return (
    <tr key={item.id} className="tb-tnx-item">
      <td className="bold"><strong>{item.bin}</strong></td>
      <td className="text-center border-l">{item.scheme}</td>
      <td className="text-center">{item.type}</td>
      <td className="text-center">{item.issuer}</td>
      <td className="text-center border-l">
        {item.country}
        {item.country && (<ReactCountryFlag countryCode={item.country} svg
          style={{
            width: '1.1em',
            height: '1.1em',
            marginTop: '-0.2em',
            marginLeft: '0.4em',
          }} />
        )}
      </td>
      <td className="text-center">{item.currency}</td>
      <td className="text-center border-l">
        {binState === true ? (
          <React.Fragment>
            <XIcon className="text-red-500 inline h-4 w-4 -mt-0.5" /> Blocked
          </React.Fragment>
        ) : (
          <React.Fragment>
            <Check className="text-green-500 inline h-4 w-4" /> Allowed
          </React.Fragment>
        )}
      </td>
      <td className="text-center border-l">
        <button
          className={`-mr-2 border px-4 font-mono uppercase py-1 ${updating === true ? 'bg-slate-800 text-white' : binState === false ? 'bg-red-500 text-white' : 'bg-violet-700 text-white'} rounded text-xs`}
          onClick={() => updateBinState()}
          disabled={updating}
        >
          {updating ? (
            <Loader2 className="h-4 w-4 animate-spin" />
          ) : binState === true ? 'Unblock' : 'Block'}
        </button>
      </td>
    </tr>
  );
}

const TableHeaders = () => (
  <React.Fragment>
    <tr className="tb-tnx-head">
      <th className="text-left">
        <strong>BIN</strong>
      </th>
      <th className="border-l">Scheme</th>
      <th>Type</th>
      <th>Issuer</th>
      <th className="border-l">Country</th>
      <th>Currency</th>
      <th className="border-l">Status</th>
      <th className="border-l">Options</th>
    </tr>
  </React.Fragment>
);

const BinRules = () => {
  const { organisation } = useSelector((state) => state);
  const endpoint = API_ROUTES.user['organisation:bin-rules'](organisation.organisation);

  return (
    <React.Fragment>

      <h3 className="font-extralight uppercase font-mono text-2xl dark:text-white text-violet-900 mb-6 border-b border-violet-900 pb-2">
        BIN Rule Configuration
      </h3>

      <DataTable
        title="Bank Identification Numbers"
        largeHeading={true}
        columnCount={8}
        TableHeaders={TableHeaders}
        RowFormatter={RowFormatter}
        PageOptions={() => <React.Fragment />}
        endpoint={endpoint}
        noHeader={true}
        childOrganisationsOption={false}
        searchPlaceholder="Bank Identification Number (BIN)"
      />
    </React.Fragment>
  );
};

export default BinRules;